
// import router from "../router/index";
// import store from "../store";
import BaseApi from "./BaseApi";

export default class ProspectService extends BaseApi {


    constructor(){
        super();
    }


    async list()
    {
        return this.http.get(`${this.baseUrl}/prospects`)
        .catch(this.handleErrorResponse);
    }


    async reminderList(sku)
    {
        return this.http.get(`${this.baseUrl}/prospects/reminders/${sku}`)
        .catch(this.handleErrorResponse);
    }


    async get(slug)
    {
        return this.http.get(`${this.baseUrl}/prospects/${slug}/edit`)
        .catch(this.handleErrorResponse);
    }

 
    async reminderGet(sku)
    {
        return this.http.get(`${this.baseUrl}/prospects/reminders/${sku}/edit`)
        .catch(this.handleErrorResponse);
    }

 

    async store(data)
    {
        return this.http.post(`${this.baseUrl}/prospects/store`,data)
        .catch(this.handleErrorResponse);
    }


    async reminderStore(sku, data)
    {
        return this.http.post(`${this.baseUrl}/prospects/reminders/${sku}/store`,data)
        .catch(this.handleErrorResponse);
    }



    async reminderUpdate(sku, data)
    {
        return this.http.put(`${this.baseUrl}/prospects/reminders/${sku}/update`,data)
        .catch(this.handleErrorResponse);
    }

    


    async update(slug, data)
    {
        return this.http.put(`${this.baseUrl}/prospects/${slug}/update`, data)
        .catch(this.handleErrorResponse);
    }



    async delete(slug)
    {
        return this.http.delete(`${this.baseUrl}/prospects/${slug}/delete`)
        .catch(this.handleErrorResponse);
    }


    async reminderDelete(sku)
    {
        return this.http.delete(`${this.baseUrl}/prospects/reminders/${sku}/delete`)
        .catch(this.handleErrorResponse);
    }

    async getSelect()
    {
        return this.http.get(`${this.baseUrl}/prospects`)
        .catch(this.handleErrorResponse);
    }

    async getSelectWithFee()
    {
        return this.http.get(`${this.baseUrl}/getFeeProspect`)
        .catch(this.handleErrorResponse);
    }

}